module.exports = __webpack_public_path__ + "static/img/1.06872ab7.jpg";